import React from 'react';

import { Component as Columns } from '../layout/Columns.jsx';
import Name from '../utility/Name.jsx';
import { default as _TypeConfig } from './TypeConfig.jsx';

function NonBreakingContainer(props) {
    let className = 'pageBreakInsideAvoid';
    if (props.className) {
        className += ` ${props.className}`;
    }
    return (
        <Columns
            {...props}
            blockType={Name.Block.NonBreakingContainer}
            className={className}
            dataType="layout"
            renderHeader={false} />
    );
}

const TypeConfig = {
    panel: {
        block: () => {
            return {
                options: [
                    { name: 'columnCount', value: '1', visible: () => false },
                    { name: 'width-col1', value: { unit: '%', value: '100' }, visible: () => false }
                ]
            };
        },
        style: () => _TypeConfig.panel.layoutStyle('block', 'Layout', {}, undefined, {})
    }
};

export {
    NonBreakingContainer as Component,
    TypeConfig
};